/**
 * The signed-in user's personal Codex and Claude credentials as CMMD holds
 * them, through the forge-server CMMD proxy prefix (/api/cmmd/*).
 *
 * @module environments/cmmdApi/providerCredentials
 */
import type { CmmdClaudeCredentialState, CmmdCodexCredentialState } from "@cmmd-forge/contracts";

import { request, type TransportConfig } from "./transport";

const USER_CODEX_CREDENTIAL_PATH = "/api/cmmd/providers/codex/credential";
const USER_CLAUDE_CREDENTIAL_PATH = "/api/cmmd/providers/claude/credential";

export function getUserCodexCredential(cfg: TransportConfig): Promise<CmmdCodexCredentialState> {
  return request<CmmdCodexCredentialState>(
    { method: "GET", path: USER_CODEX_CREDENTIAL_PATH },
    cfg,
  );
}

export function disconnectUserCodexCredential(
  cfg: TransportConfig,
): Promise<CmmdCodexCredentialState> {
  return request<CmmdCodexCredentialState>(
    { method: "DELETE", path: USER_CODEX_CREDENTIAL_PATH },
    cfg,
  );
}

export function getUserClaudeCredential(cfg: TransportConfig): Promise<CmmdClaudeCredentialState> {
  return request<CmmdClaudeCredentialState>(
    { method: "GET", path: USER_CLAUDE_CREDENTIAL_PATH },
    cfg,
  );
}

export function disconnectUserClaudeCredential(
  cfg: TransportConfig,
): Promise<CmmdClaudeCredentialState> {
  return request<CmmdClaudeCredentialState>(
    { method: "DELETE", path: USER_CLAUDE_CREDENTIAL_PATH },
    cfg,
  );
}

export function removeLinkedProviderAccount(
  cfg: TransportConfig,
  id: string | number,
): Promise<{ readonly removed: boolean }> {
  return request<{ readonly removed: boolean }>(
    { method: "DELETE", path: `/api/cmmd/providers/accounts/${encodeURIComponent(String(id))}` },
    cfg,
  );
}
